import type { Person } from 'src/tpbp-core/models/person/person.type'
import type { RelationModel } from 'src/tpbp-json-api-handler/models/models'
import type { UserInfo } from '../../../shared/stores/current-user/current-user.types'

function mapRelationToUserInfo(relation: RelationModel): UserInfo {
  return {
    id: relation._subject.id,
    lastName: relation._subject.lastName,
    firstName: relation._subject.firstName,
  }
}

function mapPersonToUserInfo(person: Person): UserInfo {
  return {
    id: person.id,
    lastName: person.lastName,
    firstName: person.firstName,
  }
}

export function getAllUserInfo(
  currentUser: Person | undefined,
  relations: RelationModel[],
): UserInfo[] {
  const currentUserInfo = currentUser
    ? mapPersonToUserInfo(currentUser)
    : undefined

  const relationsUserInfos = relations.map((relation) =>
    mapRelationToUserInfo(relation),
  )
  const relationsIds = relationsUserInfos.map((userInfo) => userInfo.id)
  const relationsUniqIds = [...new Set(relationsIds)]
  const relationsUserInfo = relationsUniqIds.map((id) =>
    relationsUserInfos.find((u) => u.id === id),
  )

  return [currentUserInfo, ...relationsUserInfo].filter(
    (userInfo): userInfo is UserInfo => userInfo !== undefined,
  )
}

export function getFullNameByUserIdFromUserInfo(
  id: string,
  allUserInfo: UserInfo[],
) {
  const userInfo = allUserInfo.find((u) => u.id === id)
  return userInfo ? `${userInfo.firstName} ${userInfo.lastName}` : ''
}
